import React, { useState, useEffect } from "react";
import CollegeHomeContainer from "../Container/CollegeHomeContainer";
import { Grid, Responsive, GridRow, Icon } from "semantic-ui-react";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import NextExpectedPayment from "./NextExpectedPayment";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./Dashboard.css";
// import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { connect } from "react-redux";
// import from Permission to use Permission functions - lieh
// import { permIndices } from '../../Permissions'
import DashboardLink from "./DashboardLink";
import { getProgressCollege } from "../../Helper/CollegeHelper";
import {API} from "../../API";
import {handleCollegeMultiDateBookings} from "../Bookings2/Helper";
import {mapStateToCityForET, shortenStatesName, teacherResponse} from "../../Helper";
import JobBoardComponent from "./JobComponentCollege";
import Spinner from "../../Components/Spinner/Spinner";
import { Link } from "react-router-dom";
import Modal from '../../Components/Modal/Modal';
import ConfirmAndCancel from '../../Components/Buttons/ConfirmAndCancel';
import CheckableButton from "../../Components/CheckableButton/CheckableButton"
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import CurrentInvoices from "./CurrentInvoice";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import { updateInstitutionInfo } from "../../redux/college/college.actions";
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);


const PersonnelDashboard = ({
  user,
  institution,
  campuses,
  personnel,
  classes,
  permissions,
  isViewAsAdmin,
  updateInstInfo
}) => {
  const [progress, setProgress] = useState(0);
  const [progressCheck, setProgressCheck] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [bookings, setBookings] = useState([]);
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const [recentBooking, setRecentBooking] = useState(undefined);
  const [bookingsLoaded, setBookingsLoaded] = useState(false);
  const [selectedCampus, setSelectedCampus] = useState(campuses?.filter(campus => campus.state)?.[0])
  const [onCheckCampus, setOnCheckCampus] = useState(campuses?.filter(campus => campus.state)?.[0])
  const [etTeacher, setETTeacher] = useState({})
  const [showSelectCampusModel, setShowSelectCampusModel] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [onLoadET, setOnLoadET] = useState(true)
  const [showContractPopup, setShowContractPopup] = useState(false)

  let etInterval


  useEffect(() => {
    API.getInstitutionDataById(institution._id)
      .then((res) => {
        const inst = res?.data;
        updateInstInfo(inst);
        setShowContractPopup((inst?.is_childcare_centre && !inst?.new_pricing_contract?.is_accepted) || (!inst?.is_childcare_centre && !inst?.new_pricing_contract?.is_accepted))
      })
      .catch(err => {
        console.log('err', err)
      })

    window.addEventListener("resize", handleResize);
    if(!isViewAsAdmin && selectedCampus?.state) {
      etInterval = setInterval(() => {
        const teacherType = user?.is_childcare_centre ? "ecec" : "elicos"

        API.getETTeacherV2(onCheckCampus, teacherType).then((res) => {
          const etTeacherNew = res?.data?.data
          if(res?.data?.data) {
            const oldCount = etTeacher?.summary?.[shortenStatesName(selectedCampus?.state)]
            const newCount = etTeacherNew?.summary?.[shortenStatesName(selectedCampus?.state)]
            const oldStatus = etTeacher?.summary?.status
            const newStatus = etTeacherNew?.summary?.status
            const oldTime = etTeacher?.summary?.opens_in
            const newTime = etTeacherNew?.summary?.opens_in
            if(oldCount !== newCount || oldStatus !== newStatus || oldTime !== newTime) {
              setETTeacher(etTeacherNew)
            }
            else {
              console.log("Reloaded ET with no change")
            }
          }
          else {
            console.log("Fail to reload ET")
          }
        })
      }, 1*60*1000)
    }

    const { progress, p_c } = getProgressCollege(
      user,
      institution,
      classes,
      campuses,
      personnel
    );
    setProgress(progress);
    setProgressCheck(p_c);
    API.getAllTeachersBrief().then((res) => {
      getBookings(institution, res.data);
    });

    if(!isViewAsAdmin && selectedCampus?.state) {
      const teacherType = user?.is_childcare_centre ? "ecec" : "elicos"
      API.getETTeacherV2(selectedCampus, teacherType).then((res) => {
        setETTeacher(res?.data?.data)
        setOnLoadET(false)
      })
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(etInterval);
    };
  }, []);

  const pointerEventsStyle = (permIndex) => {
    return {
      pointerEvents: permissions[permIndex] ? "auto" : "none",
    };
  };

  const tabs = [
    {
      pathname: "/PersonnelDashboard",
      text: "Dashboard",
      active: true,
    },
    {
      pathname: "/profile",
      text: "Institute Profile",
    },
  ];

  const getBookings = (inst, teachers) => {
    //Get access to all the bookings of the current user
    API.getCampusBookingsByInstitutionID(inst._id)
      .then((result) => {
        let list = handleCollegeMultiDateBookings(result.data)
          .filter((booking) => {
            return (
              !booking.cancelled_by_inst &&
              booking.teacher_response !== teacherResponse.cancelled
            );
          })
          .map((job) => {
            let newJob = { ...job };
            // console.log(newJob);
            if (job.teacher_id) {
              // console.log(job.teacher_id)
              if (job.teacher_response === teacherResponse.accepted) {
                newJob.teacher = teachers.find(
                  (teacher) => teacher._id === job.teacher_id
                );
              }
            }
            return newJob;
          })
          .sort((a, b) => {
            if (a.booking_date === b.booking_date) {
              return a.arrival_time > b.arrival_time ? 1 : -1;
            } else return a.booking_date > b.booking_date ? 1 : -1;
          });
        let past_bookings = [];
        let future_bookings = [];
        const today = new Date();
        const today_date = moment(new Date()).format("YYYY-MM-DD");
        const today_time = `${today
          .getHours()
          .toString()
          .padStart(2, "0")}:${today.getMinutes().toString().padStart(2, "0")}`;
        list.forEach((booking) => {
          const compare_date = booking.end_booking_date || booking.booking_date;
          if (
            compare_date > today_date ||
            (compare_date === today_date && booking.end_time > today_time)
          ) {
            future_bookings.push(booking);
          } else {
            if (booking.teacher_response === "accepted") {
              past_bookings.push(booking);
            }
          }
        });
        setBookings(list)
        setUpcomingBookings(future_bookings)
        setRecentBooking(past_bookings[past_bookings.length - 1])
        setBookingsLoaded(true)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDateText = (date) => {
    const now = moment.tz(new Date(), "Australia/Melbourne").format('ddd')
    const otherDate = moment.tz(date, "Australia/Melbourne").format('ddd')
    // console.log("check date: ", now, otherDate)
    return now === otherDate ? "today" : "tomorrow"
  }

  const handleResize = () => {
    setScreenWidth(window.innerWidth)
  };

  const onChangeETCampus = () => {
    // console.log("confirm")
    setOnLoadET(true)
    setShowSelectCampusModel(false)

    const teacherType = user?.is_childcare_centre ? "ecec" : "elicos"
    API.getETTeacherV2(onCheckCampus, teacherType).then((res) => {
      setETTeacher(res.data)
      setSelectedCampus(onCheckCampus)
      setOnLoadET(false)
    })
  }

  // const statusET = etTeacher?.summary?.status
  const statusET = "CLOSED"

  const countET = etTeacher?.summary?.[shortenStatesName(selectedCampus?.state)]
  console.log("width: ", screenWidth, selectedCampus?.state, shortenStatesName(selectedCampus?.state))
  return (
    <CollegeHomeContainer
      user={user}
      institution={institution}
      tabs={tabs}
      /* not isViewAsTeacher or isViewAsCollege - lieh */
      isViewAsPersonnel={true}
      hideViewBar
      offset={true}
      viewbookings={user.permissions.vi_book}
      removeTopMargin
    >
      <div className="dashboard-wrapper">
        {
          !isViewAsAdmin &&
          selectedCampus?.state &&
          !onLoadET ? (
          etTeacher?.summary && selectedCampus?.state && (
          <React.Fragment>

            {/* OPEN case with 1 teacher available at least */}
            {
              statusET === "OPEN" && countET > 0 && (
                <div className="d-flex justify-content-between align-items-center py-2 px-5 mb-3 bg-open mr-15">
                  
                  <div className="text-white my-3 open-info">
                    <p className="text-center fs-20">Morning Session for {getDateText(etTeacher.summary.Date)}</p>
                    <p className="text-center et-date">{moment(etTeacher.summary.Date).format('ddd DD/MM')}</p>
                    <p className="text-center fs-20">{mapStateToCityForET(shortenStatesName(selectedCampus?.state))}</p>
                    <p className="text-center fs-14 open-text pointer btn-change-location" onClick={() => setShowSelectCampusModel(true)}>Change Location</p>
                  </div>
                  <div className="open-logo d-flex flex-column justify-content-start">
                    <img className="open-img" width={280} src="../../assets/img/open-icon.png" />
                    {screenWidth < 1220 && (
                      <div className="open-content">
                        <p className="text-center et-date">
                          <span className="text-white">{countET > 5 ? "5+" : countET}</span>
                          {/* <span className="text-white">{" Teachers"} </span> */}
                          <span className="text-white">{" AVAILABLE"}</span>
                        </p>
                      </div>
                    )}
                    {screenWidth <= 530 && (
                    <div className="">
                      <Link
                        className="open-booking-btn"
                        id="openbooking"
                        title="Booking"
                        to={`/CollegeCalendar?date=${moment(etTeacher.summary.Date).format('YYYY-MM-DD')}`}
                      >
                        BOOK NOW
                      </Link>
                    </div>
                    )}
                  </div>
                  {screenWidth >= 1220 && (
                  <div className="open-content">
                    <p className="text-left et-date">
                      <span className="text-white">{countET > 5 ? "5+" : countET}</span>
                      {/* <span className="text-white">{" Teachers"} </span> */}
                      <span className="text-white">{" AVAILABLE"}</span>
                    </p>
                  </div>
                  )}
                  {screenWidth > 530 && (
                  <div className="">
                    <Link
                      className="open-booking-btn"
                      id="openbooking"
                      title="Booking"
                      to={`/CollegeCalendar?date=${moment(etTeacher.summary.Date).format('YYYY-MM-DD')}`}
                    >
                      BOOK NOW
                    </Link>
                  </div>
                  )}
                </div>
              )
            }

            {/* SOLD OUT case with no available teacher */}
            {
              statusET === "OPEN" && countET == 0 && (
                <div className="d-flex justify-content-between align-items-center py-2 px-5 mb-3 bg-sold-out mr-15">
                  <div className="text-white my-3 sold-out-info">
                    <p className="text-center fs-20">Morning Session for {getDateText(etTeacher.summary.Date)}</p>
                    <p className="text-center et-date">{moment(etTeacher.summary.Date).format('ddd DD/MM')}</p>
                    <p className="text-center fs-20">{mapStateToCityForET(shortenStatesName(selectedCampus?.state))}</p>
                    <p className="text-center fs-14 open-text pointer btn-change-location" onClick={() => setShowSelectCampusModel(true)}>Change Location</p>
                  </div>
                  <div className="sold-out-logo d-flex flex-column justify-content-start align-items-center">
                    <img className="sold-out-img" width={315} src="../../assets/img/sold-out-icon.png" />
                    {screenWidth <= 500 && (
                    <div className="sold-out-content">
                      <p className="text-center et-date">
                        <span className="text-white">{countET}</span>
                        {/* <span className="text-white">{" Teachers"} </span> */}
                        <span className="text-white">{" AVAILABLE"}</span>
                      </p>
                      <p className="text-center text-white fs-12">
                        ET booking for {getDateText(etTeacher.summary.Date)} {moment(etTeacher.summary.Date).format('DD/MM')}
                      </p>
                      <p className="text-center text-white fs-12">
                        will open in {etTeacher?.summary?.opens_in || "a few minutes"}
                      </p>
                    </div>
                    )}
                  </div>
                  {screenWidth > 500 && (
                  <div className="sold-out-content">
                    <p className="text-center et-date">
                      <span className="text-white">{countET}</span>
                      {/* <span className="text-white">{" Teachers"} </span> */}
                      <span className="text-white">{" AVAILABLE"}</span>
                    </p>
                    <p className="text-center text-white fs-16">
                      ET booking for {getDateText(etTeacher.summary.Date)} {moment(etTeacher.summary.Date).format('DD/MM')}
                    </p>
                    <p className="text-center text-white fs-16">
                      will open in {etTeacher?.summary?.opens_in || "a few minutes"}
                    </p>
                  </div>
                  )}
                </div>
              )
            }


            {/* CLOSED case */}
            {
              statusET.includes("CLOSED") && (
                <div className="d-flex justify-content-between align-items-center py-2 px-5 mb-3 bg-close mr-15">
                  <div className="my-3 close-info">
                    <p className="text-center fs-20">Morning Session for today</p>
                    <p className="text-center et-date">{moment.tz(new Date(), "Australia/Melbourne").format('ddd DD/MM')}</p>
                    <p className="text-center fs-20">{mapStateToCityForET(shortenStatesName(selectedCampus?.state))}</p>
                    <p className="text-center fs-14 close-text pointer btn-change-location" onClick={() => setShowSelectCampusModel(true)}>Change Location</p>
                  </div>
                  <div className="close-logo d-flex flex-column justify-content-start align-items-center">
                    <img className="close-img" width={270} src="../../assets/img/close-icon.png" />
                    {screenWidth <= 500 && (
                    <div className="close-content">
                      <p className="text-center et-date">
                        <span className="">0</span>
                        {/* <span className="">{" Teachers"} </span> */}
                        <span className="">{" AVAILABLE"}</span>
                      </p>
                      <p className="text-center fs-14">
                        ET booking for {getDateText(etTeacher.summary.Date)} {moment(etTeacher.summary.Date).format('DD/MM')}
                      </p>
                      <p className="text-center fs-14">
                        will open in {etTeacher.summary.opens_in || "a few minutes"}
                      </p>
                    </div>
                    )}
                  </div>
                  {screenWidth > 500 && (
                  <div className="close-content">
                    <p className="text-center et-date">
                      <span className="">0</span>
                      {/* <span className="">{" Teachers"} </span> */}
                      <span className="">{" AVAILABLE"}</span>
                    </p>
                    <p className="text-center fs-16">
                      ET booking for {getDateText(etTeacher.summary.Date)} {moment(etTeacher.summary.Date).format('DD/MM')}
                    </p>
                    <p className="text-center fs-16">
                      will open in {etTeacher.summary.opens_in || "a few minutes"}
                    </p>
                  </div>
                  )}
                </div>
              )
            }
          </React.Fragment>
          )
        ) : (
          bookingsLoaded && !isViewAsAdmin && selectedCampus?.state && <Spinner small />
        )}
        <div className="mt-10 upcoming-classes-spacing">
          {bookingsLoaded ? (
            <React.Fragment>
              <div className="row flex-row mx-0 py-4 upcoming-inner">
                {!!upcomingBookings.length ? (
                  upcomingBookings.length === 1 ? (
                    <div
                      className="col-lg-6"
                      key={upcomingBookings[0]._id}
                    >
                      <JobBoardComponent
                        job={upcomingBookings[0]}
                        bookings={bookings}
                        campuses={campuses}
                      />
                    </div>
                  ) : (
                    [<div
                      className="col-lg-4"
                      key={upcomingBookings[0]._id}
                    >
                      <JobBoardComponent
                        job={upcomingBookings[0]}
                        bookings={bookings}
                        campuses={campuses}
                        smallHeader={true}
                      />
                    </div>,
                      <div
                        className="col-lg-4"
                        key={upcomingBookings[1]._id}
                      >
                        <JobBoardComponent
                          job={upcomingBookings[1]}
                          bookings={bookings}
                          campuses={campuses}
                          smallHeader={true}
                        />
                      </div>])
                ) : (
                  <div className="col-lg-6">
                    <ProfileBox header="Upcoming Booking" />
                  </div>
                )}
                {!!recentBooking ? (
                  <div className={upcomingBookings.length > 1 ? "col-lg-4" : "col-lg-6"}
                       key={recentBooking._id}>
                    <JobBoardComponent
                      smallHeader={upcomingBookings.length > 1}
                      job={recentBooking}
                      bookings={bookings}
                      campuses={campuses}
                      recent
                    />
                  </div>
                ) : (
                  <div className={upcomingBookings.length > 1 ? "col-lg-4" : "col-lg-6"}>
                    <ProfileBox
                      header="Last Completed"
                      smallHeader={upcomingBookings.length > 1} />
                  </div>
                )}
              </div>
            </React.Fragment>
          ) : (
            <Spinner small/>
          )}
        </div>
        <div className="mx-3 mt-5 blue-box">
          <ProfileBox header="Quick Actions">
            <div className="row flex-row mx-2 py-2">
              {/* <div className="col-md-6 col-lg-3 px-0">
              <a
                href="./CollegeCalendar"
                style={pointerEventsStyle("ed_book")}>
                <div className="shadow-lg rounded-lg p-6 m-4 dashboard-tile-finished">
                  <div className="m-0 text-white font-weight-bold dashboard-tile-title">
                    <p className="text-center">
                      <b>Make a Booking</b>
                    </p>
                  </div>
                  <div className="flex justify-around m-3 text-white text-3xl">
                    <EventAvailableIcon
                      style={{ fontSize: 58 }}
                    ></EventAvailableIcon>
                    <Icon name="arrow right" size="big" color="white" />
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-6 col-lg-3 px-0">
              <div className="shadow-lg rounded-lg p-6 m-4 dashboard-tile">
                <div className="m-1 text-white font-weight-bold dashboard-tile-title">
                  <p className="text-center">Search Teachers</p>
                </div>
                <div className="flex justify-around m-3 text-white text-3xl">
                  <Icon name="search" size="big" color="white"></Icon>
                  <Icon name="arrow right" size="big" color="white" />
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 px-0">
              <div className="shadow-lg rounded-lg p-6 m-4 dashboard-tile">
                <div className="m-1 text-white font-weight-bold dashboard-tile-title">
                  <p className="text-center">View Favourites</p>
                </div>
                <div className="flex justify-around m-3 text-white text-3xl">
                  <Icon name="heart" size="big" color="white"></Icon>
                  <a>
                    <Icon name="arrow right" size="big" color="white" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 px-0">
              <div className="shadow-lg rounded-lg p-6 m-4 dashboard-tile">
                <div className="m-1 text-white font-weight-bold dashboard-tile-title">
                  <p className="text-center">Send Lesson Plan</p>
                </div>
                <div className="flex justify-around m-3 text-white text-3xl">
                  <Icon name="paper plane" size="big" color="white"></Icon>
                  <a>
                    <Icon name="arrow right" size="big" color="white" />
                  </a>
                </div>
              </div>
            </div> */}

              <div className={"p-2 dashboard-link-college" + (user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  pathname="/CollegeCalendar"
                  iconName="calendar check outline"
                  text="Make a Booking"
                  // disabled={!permissions["ed_book"]}
                  index={0}
                />
              </div>

              <div className={"p-2 dashboard-link-college" + (user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  pathname="/PostJobDraft"
                  iconName="briefcase"
                  text="Post a Vacancy"
                  index={1}
                />
              </div>

              <div className={"p-2 dashboard-link-college" + (user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  pathname="/SearchTeachers"
                  iconName="search"
                  text={user?.is_childcare_centre ? "Search Educators" : "Search Teachers"}
                  index={2}
                />
              </div>

              <div className={"p-2 dashboard-link-college" + (user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  pathname="/FavouriteTeachers"
                  iconName="heart"
                  text="View Favourites"
                  index={3}
                />
              </div>

              {
                !user?.is_childcare_centre && (
                  <div className={"p-2 dashboard-link-college" + (user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                    <DashboardLink
                      pathname="/SendLessonMaterials"
                      iconName="paper plane"
                      text="Send Lesson Plan"
                      // disabled
                      disabledText="Not available"
                      index={4}
                    />
                  </div>
                )
              }
            </div>
          </ProfileBox>
        </div>

        {/* <div className={"mx-3 pt-4 dashboard-progress" + (progress == 100 ? ' d-none' : '')}>
          <ProfileBox header="SETUP PROGRESS - ADD TO PROFILE">
            <div className="row flex-vertical-center">
              {/* this is the left part of the progress bar to show percentage */}
              {/* <div className="col-lg-2">
                <div className="row py-6">
                  <div className="col-md-3 col-lg-2"/>
                  <div className="col-md-6 col-lg-8">
                    <CircularProgressbar value={progress} text={`${progress}%`}/>
                  </div>
                  <div className="col-md-2"/>
                </div>
              </div>

              <div className="col-lg-10">
                <div className="row m-2">
                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.logo ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          <a
                            href="/profile"
                            className="pl-md-3 pt-md-3"
                            style={pointerEventsStyle("ed_col")}
                          >
                            {" "}
                            Add Company Logo
                          </a>
                        </Grid.Column>
                      </GridRow>

                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.classes ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          <a
                            href="/timetable"
                            className="pl-md-3 pt-md-3"
                            style={pointerEventsStyle("ed_cla")}
                          >
                            {" "}
                            Setup Timetable
                          </a>
                        </Grid.Column>
                      </GridRow>
                    </Responsive>
                  </div>

                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.profile_photo ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          {/* error here: CollegeAccount route cannot be accessed by Personnel */}
                          {/* <a href="/PersonnelAccount" className="pl-md-3 pt-md-3">
                            {" "}
                            Add Profile Photo
                          </a>
                        </Grid.Column>
                      </GridRow>

                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.courses ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          <a
                            href="/profile#updateCourseDeliver"
                            className="pl-md-3 pt-md-3"
                          >
                            {" "}
                            Add Course Delivered
                          </a>
                        </Grid.Column>
                      </GridRow>
                    </Responsive>
                  </div>

                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.campuses ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          <a
                            href="/campus"
                            className="pl-md-3 pt-md-3"
                            style={pointerEventsStyle("ed_cam")}
                          >
                            {" "}
                            Setup Campuses
                          </a>
                        </Grid.Column>
                      </GridRow>

                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.payment ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          <a
                            // href="/profile"
                            className="pl-md-3 pt-md-3 temp"
                            style={pointerEventsStyle("ed_pay")}
                          >
                            Add Payment Method
                          </a>
                        </Grid.Column>
                      </GridRow>
                    </Responsive>
                  </div>

                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      <GridRow className="py-3">
                        <Grid.Column>
                          {progressCheck.personnel ? (
                            <div className="rounded-circle tick-on-icon">
                              <Icon
                                name="blue thumbs up outline icon"
                                size="large"
                                // className="pl-md-2 pt-md-1"
                              ></Icon>
                            </div>
                          ) : (
                            <div className="rounded-circle tick-off-icon">
                              <Icon
                                size="large"
                                // className="pl-md-2 pt-md-2"
                              ></Icon>
                            </div>
                          )}
                        </Grid.Column>
                        <Grid.Column>
                          <a
                            href="/personnel"
                            className="pl-md-3 pt-md-3"
                            style={pointerEventsStyle("ed_per")}
                          >
                            {" "}
                            Add Personnel
                          </a>
                        </Grid.Column>
                      </GridRow>
                    </Responsive>
                  </div>
                </div>
              </div>
            </div>
          </ProfileBox>
        </div> */}

        <div className="my-10 recent-feedback">
          <div className="row flex-row mx-0 py-4">
            <div className="col-lg-6 recent-feedback">
              <ProfileBox header="Recent Feedback"></ProfileBox>
            </div>
            <div className="col-lg-6 recent-feedback">
              <CurrentInvoices user={user} />
            </div>
          </div>
        </div>

        <Modal
            show={showSelectCampusModel}
            header="Choose Campus"
            className="export-booking-modal"
            onClose={() => setShowSelectCampusModel(false)}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-8">
                <ButtonContainer
                  label="Select campus"
                  className="p-0 mx-0"
                >
                  <div className="col-md-12 px-0">
                    {campuses?.filter(campus => campus.state)?.map((campus, index) => {
                      return (
                        <CheckableButton
                          checkbox
                          // noBorder
                          id={campus._id}
                          title={index}
                          onChange={() => setOnCheckCampus(campus)}
                          checked={campus._id === onCheckCampus._id}
                        >
                          {campus.address_line1 + (
                            campus.address_line2 ? ', ' + campus.address_line2 : '') + ', ' + campus.suburb}
                        </CheckableButton>
                      )
                    })}
                  </div>
                </ButtonContainer>
              </div>
              <div className="w-100">
                <ConfirmAndCancel
                  onCancel={() => setShowSelectCampusModel(false)}
                  cancelText='Go Back'
                  onConfirm={() => onChangeETCampus()}
                  confirmText='Change'
                />
              </div>
            </div>
          </Modal>
          <Modal
            className="w-50"
            header="We've updated our Terms and Conditions"
            // onClose={this.closeContractPopup}
            show={showContractPopup}
          >
            <p className="center-text fs-20">
              Please view and accept our Terms and Conditions to continue. We'll email you a copy upon completion.
            </p>
            <p className="center-text mt-3" style={{'lineHeight': 'normal'}}>
              <small>
               New Pricing Schedule for ELICOS & VET added as appendix.
              </small>
            </p>
            <br />
            <div className="d-flex justify-center">
              <ConfirmButton onClick={() => window.location = "/SignContract"}>
                View Terms and Conditions
              </ConfirmButton>
            </div>
          </Modal>
      </div>
    </CollegeHomeContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
    personnel: state.college.personnel,
    classes: state.college.classes,
    // permission field to allow less verbose code - lieh
    permissions: state.college.permissions || {},
  };
}

const mapDispatchToProps = (dispatch) => ({
  updateInstInfo: (inst) => dispatch(updateInstitutionInfo(inst)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelDashboard);
